var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DividedList',{staticClass:"sidebar-list",attrs:{"items":_vm.items,"list-item":_vm.listItem,"empty-message":_vm.emptyMessage}},[_c('template',{slot:"top"},[(_vm.parent)?_c('BackListItem',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"parent":_vm.parent}}):_vm._e(),(_vm.parent && _vm.items.length)?_c('v-divider'):_vm._e()],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }